import { render, staticRenderFns } from "./QuestionEditQuick.vue?vue&type=template&id=245e0c99&"
import script from "./QuestionEditQuick.vue?vue&type=script&lang=js&"
export * from "./QuestionEditQuick.vue?vue&type=script&lang=js&"
import style0 from "./QuestionEditQuick.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports